import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
              Entdecken
            </p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Top Kategorien
            </h2>
          </div>
          <p className="mt-2 md:mt-0 text-sm text-foreground-500 max-w-sm">
            Alle 14 Kategorien sind &uuml;ber das Dropdown-Men&uuml; in der Navigation erreichbar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-6">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer md:row-span-2"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Elegant%20white%20minimalist%20sneakers%20pair%20resting%20on%20warm%20sand%20tone%20studio%20surface%20soft%20natural%20daylight%20gentle%20shadows%20editorial%20product%20photography%20fresh%20modern%20European%20aesthetic%20clean%20composition%20high%20end%20fashion&width=600&height=750&seq=cat-img-shoes&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
            <div className="relative z-10 flex flex-col justify-end p-5 md:p-6 h-[400px] md:h-[500px]">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white">
                Schuhe
              </h3>
              <p className="mt-1 text-sm text-white/70">
                Jetzt entdecken auf kaspreadsheet.com
              </p>
              <span className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium group-hover:bg-white/30 transition-colors w-fit">
                Ansehen
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Luxurious%20oversized%20hoodie%20in%20soft%20oatmeal%20beige%20tone%20draped%20elegantly%20on%20warm%20cream%20studio%20backdrop%20minimal%20composition%20soft%20natural%20lighting%20editorial%20product%20photography%20modern%20European%20aesthetic%20cozy%20texture&width=600&height=750&seq=cat-img-hoodies&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
            <div className="relative z-10 flex flex-col justify-end p-5 md:p-6 h-[240px] md:h-[240px]">
              <span className="absolute top-4 left-4 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold">
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-fire-line"></i>
                </span>
                Beliebt
              </span>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white">
                Hoodies/Sweater
              </h3>
              <p className="mt-1 text-sm text-white/70">
                Jetzt entdecken auf kaspreadsheet.com
              </p>
              <span className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium group-hover:bg-white/30 transition-colors w-fit">
                Ansehen
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-921/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden cursor-pointer"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Elegant%20designer%20leather%20handbag%20in%20camel%20brown%20tone%20on%20warm%20cream%20studio%20backdrop%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20sophisticated%20modern%20European%20luxury%20feel&width=600&height=750&seq=cat-img-bags&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
            <div className="relative z-10 flex flex-col justify-end p-5 md:p-6 h-[240px] md:h-[240px]">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white">
                Taschen
              </h3>
              <p className="mt-1 text-sm text-white/70">
                Jetzt entdecken auf kaspreadsheet.com
              </p>
              <span className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium group-hover:bg-white/30 transition-colors w-fit">
                Ansehen
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </div>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com/search-913/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t%20shirt%20nearly%20folded%20on%20warm%20cream%20background%20minimal%20studio%20setup%20soft%20natural%20lighting%20clean%20editorial%20product%20photography%20modern%20European%20fashion%20aesthetic%20simple%20elegance&width=600&height=750&seq=cat-img-tshirts&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                T-Shirts
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-914/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Stylish%20modern%20bomber%20jacket%20in%20neutral%20sand%20beige%20color%20laid%20flat%20on%20warm%20cream%20studio%20surface%20soft%20natural%20lighting%20minimal%20editorial%20photography%20clean%20European%20aesthetic%20fashion%20forward&width=600&height=750&seq=cat-img-jackets&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Jacken
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-915/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Elegant%20tailored%20trousers%20in%20warm%20khaki%20tone%20neatly%20arranged%20on%20cream%20studio%20backdrop%20soft%20natural%20light%20minimal%20editorial%20product%20photography%20modern%20European%20fashion%20aesthetic%20clean%20lines&width=600&height=750&seq=cat-img-pants&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Hosen/Shorts
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-916/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Trendy%20minimalist%20baseball%20cap%20in%20cream%20beige%20tone%20on%20warm%20studio%20background%20soft%20natural%20daylight%20clean%20editorial%20product%20photography%20modern%20European%20streetwear%20aesthetic%20simple%20stylish&width=600&height=750&seq=cat-img-headwear&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Kopfbedeckung
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-917/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Coordinated%20fashion%20set%20of%20matching%20top%20and%20bottom%20in%20neutral%20warm%20tones%20arranged%20harmoniously%20on%20cream%20studio%20backdrop%20soft%20natural%20lighting%20editorial%20photography%20modern%20European%20aesthetic&width=600&height=750&seq=cat-img-sets&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Sets
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-918/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Soft%20premium%20cotton%20underwear%20set%20in%20warm%20beige%20tone%20delicately%20arranged%20on%20cream%20studio%20backdrop%20soft%20natural%20lighting%20minimal%20editorial%20photography%20clean%20European%20aesthetic%20intimate%20texture&width=600&height=750&seq=cat-img-underwear&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Unterw&auml;sche
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-919/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Premium%20sports%20jersey%20shirt%20in%20neutral%20cream%20tone%20with%20subtle%20design%20elements%20on%20warm%20studio%20backdrop%20soft%20natural%20lighting%20editorial%20product%20photography%20modern%20European%20athletic%20aesthetic&width=600&height=750&seq=cat-img-jersey&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Trikots
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-920/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Collection%20of%20elegant%20fashion%20accessories%20including%20sunglasses%20watch%20and%20bracelet%20arranged%20on%20warm%20cream%20studio%20surface%20soft%20natural%20lighting%20editorial%20photography%20modern%20European%20luxury%20aesthetic&width=600&height=750&seq=cat-img-accessories&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Accessoires
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-922/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20in%20warm%20brown%20tone%20elegantly%20coiled%20on%20cream%20studio%20backdrop%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20modern%20European%20accessories%20aesthetic&width=600&height=750&seq=cat-img-belts&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                G&uuml;rtel
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-923/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20cream%20studio%20backdrop%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20sophisticated%20modern%20European%20luxury%20fragrance%20aesthetic&width=600&height=750&seq=cat-img-perfumes&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Parfums
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-924/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden cursor-pointer h-[140px] md:h-[160px]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
              style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=Assorted%20stylish%20lifestyle%20products%20including%20notebook%20wallet%20and%20keychain%20arranged%20on%20warm%20cream%20studio%20backdrop%20soft%20natural%20lighting%20editorial%20photography%20modern%20European%20minimalist%20aesthetic&width=600&height=750&seq=cat-img-other&orientation=portrait')" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/5 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
              <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">
                Sonstiges
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}